/* Lushi: toggle body.scrolled class when user scrolls past 100px so the
   sticky header switches from transparent to Rain Forrest (matches v1
   .nav -> .navScrolled behavior). */
(function () {
  if (typeof window === 'undefined') return;

  function update() {
    if (window.scrollY > 80) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }
  }

  update();
  window.addEventListener('scroll', update, { passive: true });
})();
